import { useTenantImages } from "@b2bportal/core-themes";
import {
  ProductType,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { TripsCard } from "@tenant/trips";
import { TripsReservationStatusPill } from "@tenant/ui";
import clsx from "clsx";
import {
  usePackageReservationCard,
  type UsePackageReservationCardProps,
} from "./usePackageReservationCard";

export interface PackageReservationCardProps
  extends PlatformComponentProps,
    UsePackageReservationCardProps {}

export const PackageReservationCard = (props: PackageReservationCardProps) => {
  const { className, children, reservation } = props;
  const { handlers, text } = usePackageReservationCard(props);
  const images = useTenantImages();

  return (
    <TripsCard
      className={clsx(className)}
      title={text.title}
      onClick={handlers.selectItinerary}
      confirmationCode={text.confirmation}
      description={text.description}
      date={text.dates}
      image={images.packagePlaceholder}
      status={
        <TripsReservationStatusPill
          variant={ProductType.PACKAGE}
          status={reservation.state}
        />
      }
    >
      {children}
    </TripsCard>
  );
};
